<template>
  <nuxt-link
    v-if="$isRolf"
    :to="localeURLs['info-connections']"
    class="bg-dirty-blue p-4 flex flex-col sm:flex-row rounded-lg items-end sm:items-center justify-between w-full text-black group"
  >
    <div class="flex flex-col space-y-2 pr-5 text-start mb-3 sm:mb-0">
      <strong
        class="text-lg"
        data-i18n="tripDeparture.findConnection"
      >
        {{ $t('tripDeparture.findConnection') }}
      </strong>
      <span data-i18n="tripDeparture.alternatives">
        {{ $t('tripDeparture.alternatives') }}
      </span>
    </div>
    <div
      class="bg-secondary text-white rounded-full font-bold h-min px-4 py-2 text-nowrap group-hover:bg-blue-700 flex items-center"
      data-i18n="readMore"
    >
      {{ $t('readMore') }}
      <fa
        class="pl-1"
        icon="arrow-right"
      />
    </div>
  </nuxt-link>
</template>

<script setup>
const { urls: localeURLs } = useLocale()
</script>